import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  baseURL = environment.baseUrl + 'admin';

  constructor(private http: HttpClient) {
  }

  saveUser(body: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}`, body);
  }

  getAllUser(page: number, size: number, keyword: string,countryId:any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/getAll`, {
      params: new HttpParams()
        .append('page', page)
        .append('size', size)
        // .append('keyword', keyword)
        .append('countryId',countryId)
    });
  }

  updateUser(adminId: any, body: any) {
    const params = new HttpParams()
      .set('adminId', adminId)
    return this.http.put<any>(`${this.baseURL}/update`, body, {params});
  }

  inactiveUser(adminId: any,status:boolean): Observable<any> {
    const params = new HttpParams()
      .set('adminId', adminId)
      .set('status', status)
    return this.http.put<any>(`${this.baseURL}/changeStatus`, {}, {params})
  }
  getVerifyUser(): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/getVerification`);
  }

}
